import axios from 'axios';
import { useAuthStore } from '../stores/auth';
import router from '../router';
import VersionService from '@/services/VersionService';

let authInterceptorInitialized = false;

// Axios-Interceptor für Session-Validierung
export function setupAuthInterceptor() {
  if (authInterceptorInitialized) {
    return;
  }

  authInterceptorInitialized = true;

  // Bestehende Interceptors
  axios.interceptors.response.use(
    response => response,
    error => {
      // Bei 401-Fehlern (Unauthorized) automatisch ausloggen
      if (error.response && error.response.status === 401) {
        console.warn('🔑 Sitzung abgelaufen oder ungültig. Sie werden abgemeldet.');
        const authStore = useAuthStore();

        // Auth-Status zurücksetzen
        authStore.resetSession();

        // Zur Login-Seite navigieren
        if (router.currentRoute.value.path !== '/') {
          router.push('/');
        }
      }
      return Promise.reject(error);
    }
  );

  // Füge Version zu allen Requests hinzu
  axios.interceptors.request.use(config => {
    // Cookies mit allen Requests senden (für Auth)
    config.withCredentials = true;

    // Füge Versionsinformationen als Header hinzu
    const versionParams = VersionService.getVersionParams();

    // Header einzeln setzen statt das ganze Objekt zu überschreiben
    Object.entries(versionParams).forEach(([key, value]) => {
      if (config.headers) {
        config.headers.set(key, value.toString());
      }
    });

    // Füge Cache-Busting-Parameter zu GET-Anfragen hinzu
    if (config.method?.toLowerCase() === 'get' && config.url) {
      config.url = VersionService.addVersionToUrl(config.url);
    }

    return config;
  });
}
